import React, { useEffect, useState } from "react";
import {
  MDBAlert,
  MDBBtn,
  MDBChip,
  MDBChipsInput,
  MDBIcon,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import PopupLoader from "../../../views/popups/PopupLoader";
import {AddRemoveNumbers} from "../../../views/popups/phonenumbers/AddRemoveNumbers";
import DeleteHGNumber from "../../../views/popups/hunt/DeleteHGNumber";
import { useNavigate } from "react-router";
import { getMisc } from "../../../apiclients/streamsapi_bridge";
import AudioPlayer from "../../mediaplayers/AudioPlayer";

const UserVoicemails = ({
  register,
  setValue,
  errors,
  vmailFormats,
  vmailpin,
  greetingsInfo,
  userAgentId,
  watch,
  clearErrors,
  voicemailEAddress
}) => {
  const { t, i18n } = useTranslation();
  const [vmailformat, setVmailFormat] = useState({});
  const [vmailfmt, setVmailFmt] = useState(vmailFormats);
  const [vmailspin, setVmailsPin] = useState(0);
  const { busy, unavailable } = greetingsInfo ?? {};

  const vmailActive = watch("voice_mail.vmail_active");
  useEffect(() => {
    setVmailFmt(vmailFormats);
  }, [vmailFormats]);
  useEffect(() => {
    async function fetchData() {
      console.log(sessionStorage.getItem("admin_session"));
      const response = await getMisc(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        { misc: ["vmlformat"] }
      );
      if (!response.json) {
        const message = `An error has occured: ${response.statusText}`;
        return;
      }
      const tdata = await response.json();
      if (!tdata) {
        window.alert(`info with id  not found`);
        //navigate("/");
      }
      setVmailFormat(tdata.misc.vmlformat);
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (!vmailActive) {
      setValue("voice_mail.email_address", undefined, { shouldDirty: false });
    }
  })
  return (
    <>
      <div className="general-settings" id="voicemail">
        {t("Voicemail")}
      </div>
      <div className="margin-top">
        <div className="add-numbermain">
          <div className="tel-numbers">{t("Pin")}</div>
          <div className="d-flex flex-column w-30">
            <input
              type="text"
              {...register("voice_mail.vmail_pin", {
                setValueAs: (value) => Number(value),
              })}
              className="selectname w-100"
            />
            {errors?.voice_mail?.vmail_pin && (
              <p className="text-danger">
                {errors?.voice_mail?.vmail_pin?.message}
              </p>
            )}
          </div>
        </div>
        <div className="add-numbermain align-items-start">
          <div className="tel-numbers">{t("unavaliableGreeting")}</div>
          {userAgentId && userAgentId !== "" && (
            <AudioPlayer
              uniqueId={userAgentId}
              greetingType={unavailable?.greeting_type ?? 1}
              greetingId={unavailable?.greeting_id ?? 0}
              fileName={unavailable?.filename ?? ""}
              title={t("VoicemailUnavailableGreeting")}
              greetingMode={unavailable?.filename ?? "" !== "" ? 1 : 2}
              greetingTitle = {unavailable?.title ?? ""}
              greetingObject = {unavailable ?? null}
              userFlag={true}
            />
          )}
        </div>
        {/* <div className="add-numbermain align-items-start">
          <div className="tel-numbers">{t("busyGreeting")}</div>

          {userAgentId && userAgentId !== "" && (
            <AudioPlayer
              uniqueId={userAgentId}
              greetingType={busy?.greeting_type ?? 2}
              greetingId={busy?.greeting_id ?? 0}
              fileName={busy?.filename ?? ""}
              title={t("VoicemailBusyGreeting")}
              greetingMode={busy?.filename ?? "" !== "" ? 1 : 2}
            />
          )}
        </div> */}
        {/* <div className="add-numbermain">
          <div className="tel-numbers">
            {t("play_Mess_timestamp")}
            <br />
          </div>

          <div className="phoneselect">
            <label className="switch">
              <input
                className="form-control"
                {...register("voice_mail.announcertime")}
                type="checkbox"
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div> */}

<div className="add-numbermain">
              <div className="tel-numbers">{t("include_Transcript")}<br/>
                <span className="phrecording text-secondary">
                  {t("vmail_copy_trans_text")}
                </span>
              </div>

              <div className="phoneselect">
                <label className="switch">
                  <input
                    className="form-control"
                    {...register("voice_mail.email_transcript")}
                    type="checkbox"
                  />
                  <span className="slider round"></span>
                </label>
                {errors?.voice_mail?.email_transcript && (
                    <p className="text-danger">
                      {errors?.voice_mail?.email_transcript?.message}
                    </p>
                )}
              </div>
            </div>
        <div className="add-numbermain">
          <div className="tel-numbers">
            {t("email_notif")}
            <br />
          </div>

          <div className="phoneselect">
            <label className="switch">
              <input
                className="form-control"
                {...register("voice_mail.vmail_active",{
                      onChange: (e) => {
                    if (!e.target.checked) {
                      setValue("voice_mail.email_address", voicemailEAddress, { shouldDirty: true });
                    }
                        // clear error of email_notify
                        clearErrors("voice_mail.email_address");
                      },
                    })
                }
                type="checkbox"
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>
        {watch("voice_mail.vmail_active") && (
          <div className="add-numbermain">
            <div className="tel-numbers">{t("email_address")} <br />
                <span className="phrecording text-secondary">
                   {t("vmail_copy_email_text")}
                 </span>
            </div>
            <div className="w-30">
              <input
                type="text"
                 {...register("voice_mail.email_address", {
                  required: "Email Address should not be empty"                  
                })}
                // onChange={(e) => {
                //   e.preventDefault();
                //   setValue("voice_mail.email_address", parseInt(e.target.value), { shouldDirty: true });
                //   setVmailsPin(parseInt(e.target.value));
                // }}
                className="selectname w-100"
              />
              {errors?.voice_mail?.email_address && (
                <p className="text-danger">
                  {errors?.voice_mail?.email_address?.message}
                </p>
              )}
            </div>
          </div>
        )}
        <div className="add-numbermain">
          <div className="tel-numbers">{t("VoiceMailFormat")}</div>
          <div className="phoneselect w-30">
            <select
              className="form-control form-select selectname w-100"
              name="San Jose"
              value={vmailfmt}
              onChange={(e) => {
                e.preventDefault();
                setValue("voice_mail.vmlformat", parseInt(e.target.value), {
                  shouldDirty: true,
                });
                setVmailFmt(parseInt(e.target.value));
              }}
            >
              {vmailformat &&
                Object.entries(vmailformat).map(([key, value]) => (
                  <option key={key} value={key}>
                    {value}
                  </option>
                ))}
            </select>
            {errors?.voice_mail?.vmlformat && (
              <p className="text-danger">
                {errors?.voice_mail?.vmlformat?.message}
              </p>
            )}
          </div>
        </div>
        {watch("voice_mail.vmail_active") && (
          <>
            <div className="add-numbermain">
              <div className="tel-numbers">{t("del_send_message")}</div>

              <div className="phoneselect">
                <label className="switch">
                  <input
                    className="form-control"
                    {...register("voice_mail.vmail_delete")}
                    type="checkbox"
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
           
          </>
        )}
      </div>
    </>
  );
};
export default UserVoicemails;
